import { ZERO_ADDRESS } from '@blockcatio/tabby-library/lib/constants';

/**
 * Get the proper default gas limit based on payment type/method.
 * Note: The return isn't a price, it's the max amount of gas that can be used.
 *
 * @param {String} tokenAddress
 * @param {Bool} payWithCat
 * @param {Object} gasLimits
 * @returns {Number}
 */
export default (tokenAddress, payWithCat, gasLimits) => {
  if (payWithCat) {
    if (tokenAddress !== ZERO_ADDRESS) {
      return gasLimits.createPaymentGasLimitTokenByCat;
    }
    return gasLimits.createPaymentGasLimitEthByCat;
  } else if (tokenAddress !== ZERO_ADDRESS) {
    return gasLimits.createPaymentGasLimitTokenByEth;
  }
  return gasLimits.createPaymentGasLimitEthByEth;
};



// WEBPACK FOOTER //
// ./src/utilities/getCreatePaymentGasLimit.js